import { SharedModule } from '../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatronSearchComponent } from '../../../components/side-nav/patron-search/patron-search.component';
import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  imports: [CommonModule, SharedModule, ComponentsModule],
  declarations: [PatronSearchComponent],
  exports: [PatronSearchComponent],
})
export class HoldSharedModule {}
